import { statusKey } from "@/data/mockLoads";
import { CircleDot, Truck, Send, CheckCheck } from "lucide-react";

const ICONS = {
  assigned:   CircleDot,
  dispatched: Send,
  in_transit: Truck,
  delivered:  CheckCheck,
};

export const StatusBadge = ({ status }) => {
  const key = statusKey(status);
  const Icon = ICONS[key] || CircleDot;
  return (
    <span
      className={`rd-badge rd-badge-${key}`}
      data-testid={`status-badge-${key}`}
    >
      <Icon size={12} strokeWidth={3} />
      {status}
    </span>
  );
};
